import { render, staticRenderFns } from "./inspectionManagement.vue?vue&type=template&id=18942163&scoped=true"
import script from "./inspectionManagement.vue?vue&type=script&lang=js"
export * from "./inspectionManagement.vue?vue&type=script&lang=js"
import style0 from "./inspectionManagement.vue?vue&type=style&index=0&id=18942163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18942163",
  null
  
)

export default component.exports